import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import OrderCancelConfirmModal from '../../../../views/order/common/modal/OrderCancelConfirmModal';
import { orderActions } from '../../../../store/modules/order';
import withModal from '../../../../lib/hoc/withModal';

class CancelSalesConfirmModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderItemList: props.data.orderItemList,
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'cancelSalesConfirmModal',
    });
  };

  setOrderItemList = (list) => {
    this.setState({ orderItemList: list });
  };

  onSubmit = () => {
    const { form, cancelSales, data } = this.props;
    const { orderItemList } = this.state;
    const { reasonType, reason } = data;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      cancelSales({
        reasonType,
        reason,
        orderItemList: orderItemList.map((item) => ({
          isDisabledEdit: item.isDisabledEdit,
          orderItemId: item.orderItemId,
          productId: item.productId,
          productOptionId: item.productOptionId,
          newProductType: item.newProductType,
          newStockCount: item.newStockCount,
          newStatus: item.newStatus,
        })),
      });
    });
  };

  render() {
    const { form, isOpen, data } = this.props;

    return (
      <OrderCancelConfirmModal
        form={form}
        isOpen={isOpen}
        data={data}
        {...this.state}
        closeModal={this.closeModal}
        setOrderItemList={this.setOrderItemList}
        onSubmit={this.onSubmit}
        okText="판매 취소"
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.cancelSalesConfirmModal.isOpen,
    data: state.order.cancelSalesConfirmModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  cancelSales: orderActions.cancelSales,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(CancelSalesConfirmModalContainer)));
